const $inject = [];
const lbaBooleanRestrictionSelect = function () {
  return {
    restrict: 'A',
    scope: {
      settings: '<'
    },
    bindToController: true,
    controller: 'lbaBooleanRestrictionSelectCtrl',
    controllerAs: 'vm',
    template: require('./lbaBooleanRestrictionSelect.html')
  }
};

lbaBooleanRestrictionSelect.$inject = $inject;

export default lbaBooleanRestrictionSelect;



// WEBPACK FOOTER //
// ./src/components/lbaBooleanRestrictionSelect/lbaBooleanRestrictionSelectDir.js